'use client';

import { IMediaFileResponse } from '@/types/common';
import { getCdnUrl } from '@/utils/image';
import * as styles from './topVideo.css';

interface ITopVideoProps {
  additionalImage: IMediaFileResponse;
}

export const TopVideo = ({ additionalImage }: ITopVideoProps) => {
  return (
    <video
      className={styles.video}
      autoPlay
      muted
      loop
      controls={false}
      poster={getCdnUrl('/images/gacha/sale_page_default_poster.png')}
      playsInline>
      <source src={additionalImage.url} type="video/mp4" />
    </video>
  );
};
